<script setup lang="ts">
  import { useRouter } from 'vue-router';
  import { useSplashStore } from '~/stores/useSplashStore';

  const router = useRouter();
  const splashStore = useSplashStore();

  // Se nenhuma splash foi acionada pelo router guard, usar comportamento padrão
  onMounted(() => {
    if (!splashStore.isShowing) {
      setTimeout(() => {
        router.replace({ name: 'dashboard' });
      }, 5000);
    }
  });
</script>

<template>
  <splash-screen />
</template>

<route lang="yaml">
name: index
meta:
  layout: clear
  isAuthRequired: false
</route>
